export var LogLevel;
(function (LogLevel) {
    LogLevel["Debug"] = "DEBUG";
    LogLevel["Warn"] = "WARN";
    LogLevel["Verbose"] = "VERBOSE";
    LogLevel["Error"] = "ERROR";
    LogLevel["Info"] = "INFO";
    LogLevel["Log"] = "LOG";
    LogLevel["Trace"] = "TRACE";
})(LogLevel || (LogLevel = {}));
//# sourceMappingURL=console.js.map